import { render, staticRenderFns } from "./PurchaseManager.vue?vue&type=template&id=35506b53&scoped=true&"
import script from "./PurchaseManager.vue?vue&type=script&lang=ts&"
export * from "./PurchaseManager.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseManager.vue?vue&type=style&index=0&id=35506b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35506b53",
  null
  
)

export default component.exports